import React, { Component } from 'react';
import './styles/index.css';

class EmptySquare extends Component {
  render() {
    return(<span className="cell"></span>)
  }
}

export default EmptySquare;



// WEBPACK FOOTER //
// ./src/EmptySquare.js